import { apiClient } from './apiClient';
import { call, response } from './apiHelpers';

export const electionDayService = {
  getAll: async (filters) => {
    const payload = await apiClient.get('election-day/', { params: filters });
    const normalized = response(payload);
    return {
      ...normalized,
      meta: { ...(normalized.meta || {}), can_mark: Boolean(payload.can_mark) },
    };
  },
  getSummary: () => call('get', 'election-day/summary/'),
  setStatus: (voterId, hasVoted) =>
    call('post', `election-day/voters/${voterId}/status/`, {
      has_voted: hasVoted,
    }),
};
